<template id="servicos-icons">
    <article class="wfs-feature col-md-4">
      <a :href="link" target="_blank" style="color:#fff">
        <img
          :src="'img/icons-site/'+img"
          :alt="titulo"
          class="feature-info-icon"
        />
          <div class="feature-info-title">{{titulo}}</div>
      </a>
      <p class="feature-info-paragraph">
        {{texto}}
      </p>
    </article>
</template>

<script>
export default {
  name: "reload-v1",
  props: {
    link:{
      type: String,
      default: "#",
    },
    img:{
      type: String,
      default: '', 
    },
    titulo:{
      type: String,
      default: "",
    },
    texto:{
      type: String,
      default: "",
    }
  },
  methods: {

  },
};
</script>

